import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AudioMuteIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.84 3.86L19.16 5.16L4.24 20.06L2.94 18.76L6.02 15.68H2.3V8.26H6.3C7.06 8.26 7.44 8.12 8.02 7.64L12.96 3.52V8.74L17.84 3.86ZM4.02 14H7.7L11.32 10.38V6.98L9.14 8.9C8.32 9.64 7.68 9.9 6.7 9.9H4.02V14ZM12.96 20.4L9.78 17.42L12.96 14.44V20.4Z" />
    </SvgIcon>
  );
});
